module.exports = __webpack_public_path__ + "img/selected-everything.f6d7ac2f.webp";